// The Node tests evaluate this file as plain JavaScript (scripts/lib/load-axios-client.js): a type annotation breaks them.
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import store from '../store';
import authSlice from '../store/slices/auth';

const axiosService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosService.interceptors.request.use(async config => {
  const { token } = store.getState().auth;

  if (token !== null) {
    config.headers.Authorization = `Bearer ${token}`;
    // @ts-ignore
    // Console.debug('[Request]', config.baseURL + config.url, JSON.stringify(token));
  }
  return config;
});

axiosService.interceptors.response.use(
  res => {
    // @ts-ignore
    // Console.debug('[Response]', res.config.baseURL + res.config.url, res.status, res.data);
    return Promise.resolve(res);
  },
  error => {
    // Console.debug('[Response]', err.config.baseURL + err.config.url, err.response.status, err.response.data);
    /*
     * When a refresh fails, axios-auth-refresh cancels every request issued while it was running, with this
     * message. A search the app aborts itself is a cancel too, but not this one.
     */
    const refreshFailed = axios.isCancel(error) && error.message === 'Request call failed';
    return Promise.reject({
      ...error,
      status: error.response?.status || '',
      statusText: error.response?.statusText || '',
      message: error.response?.data?.detail || (refreshFailed ? 'The session could not be renewed.' : ''),
    });
  }
);

// @ts-ignore
const refreshAuthLogic = async failedRequest => {
  const { refreshToken } = store.getState().auth;
  if (refreshToken !== null) {
    return axios
      .post(
        '/auth/refresh/',
        {
          refresh: refreshToken,
        },
        {
          baseURL: process.env.REACT_APP_API_URL,
        }
      )
      .then(resp => {
        const { access } = resp.data;
        failedRequest.response.config.headers.Authorization = `Bearer ${access}`;
        store.dispatch(authSlice.actions.setAuthTokens({ token: access }));
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response?.status === 401) {
          store.dispatch(authSlice.actions.logout());
        }
        // Resolving here makes axios-auth-refresh resend the request with the stale token.
        return Promise.reject(err);
      });
  }
  // Falling off the end resolves too, and the library resends with the stale token.
  return Promise.reject(failedRequest);
};

createAuthRefreshInterceptor(axiosService, refreshAuthLogic);

export default axiosService;
